export default {"src":"/_next/static/media/change-event-chronosphere.01cad063.svg","height":17,"width":17,"blurWidth":0,"blurHeight":0};